export default {
  methods: {
    convertSecondsToTime (diff, isFormat) {
      const hours = Math.floor(diff / 60 / 60)
      const minutes = Math.floor(diff / 60) - (hours * 60)
      const seconds = diff % 60

      if (isFormat) {
        const formatted = [
          hours.toString().padStart(2, '0'),
          minutes.toString().padStart(2, '0'),
          seconds.toString().padStart(2, '0')
        ].join(':')

        return formatted
      }

      return {
        hours, minutes, seconds
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/convertSecondsToTime.js